module.exports = __webpack_public_path__ + "static/media/4.22_preview.34b0f508.png";